import styled from 'styled-components';
import HappyGostaySvg from './happyGostay.svg';

const HappyGostayIcon = styled(HappyGostaySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.ash.base};
  cursor: pointer;
`;

export default HappyGostayIcon;
